import { render, staticRenderFns } from "./SysMessageTemplateList.vue?vue&type=template&id=1eb20e02&scoped=true"
import script from "./SysMessageTemplateList.vue?vue&type=script&lang=js"
export * from "./SysMessageTemplateList.vue?vue&type=script&lang=js"
import style0 from "./SysMessageTemplateList.vue?vue&type=style&index=0&id=1eb20e02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb20e02",
  null
  
)

export default component.exports